import { HelpCircle, X } from 'lucide-react'
import {
  WORK_TYPE_LEVELS,
  WORK_TYPE_LEVEL_META,
} from '../../utils/workTypeLevels'

interface WorkTypeLevelsHelpModalProps {
  isOpen: boolean
  onClose: () => void
}

export function WorkTypeLevelsHelpModal({
  isOpen,
  onClose,
}: WorkTypeLevelsHelpModalProps) {
  if (!isOpen) return null

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-lg max-h-[90vh] flex flex-col">
        <div className="flex items-center justify-between p-4 border-b border-gray-200">
          <div className="flex items-center gap-2">
            <HelpCircle className="w-5 h-5 text-teal-600" />
            <h2 className="text-lg font-semibold text-gray-900">Work type levels</h2>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 transition-colors"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        <div className="p-4 overflow-y-auto space-y-4">
          <p className="text-sm text-gray-600">
            Levels describe how productised a work type is — from one-off bespoke
            engineering through to fully DIY client work on PRENGUIN.
          </p>
          <ul className="space-y-3">
            {WORK_TYPE_LEVELS.map((level) => {
              const meta = WORK_TYPE_LEVEL_META[level]
              return (
                <li
                  key={level}
                  className="flex gap-3 rounded-lg border border-gray-200 p-3"
                >
                  <span
                    className="flex-shrink-0 inline-flex items-center justify-center w-9 h-9 rounded-full border bg-white text-base font-bold tabular-nums"
                    style={{ color: meta.color, borderColor: `${meta.color}55` }}
                  >
                    {level}
                  </span>
                  <div className="min-w-0">
                    <p className="text-sm font-semibold text-gray-900">
                      {meta.filterLabel}
                    </p>
                    <p className="text-sm text-gray-600 mt-0.5">{meta.description}</p>
                  </div>
                </li>
              )
            })}
          </ul>
        </div>

        <div className="flex justify-end p-4 border-t border-gray-200 bg-gray-50">
          <button
            type="button"
            onClick={onClose}
            className="px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-100 text-sm"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  )
}
